import useCreateErrorReport from '@/hooks/use-create-error-report';
import { useEffect } from 'react';
import { AiFillBug } from 'react-icons/ai';
import { Link } from 'react-router-dom';

const FallbackErrorPage = ({
  resetErrorBoundary,
  error,
}: {
  resetErrorBoundary: () => void;
  error: Error;
}) => {
  const { mutateAsync } = useCreateErrorReport();

  useEffect(() => {
    mutateAsync({
      error_data: `Frontend Error Boundary Triggered:
${error}
URL: ${window.location.href}
User Agent: ${navigator.userAgent}
Timestamp: ${new Date().toISOString()}`,
    });
  }, []);

  return (
    <main className='flex h-screen w-screen items-center justify-center rounded-md bg-white p-4'>
      <div className='flex'>
        <div className='shrink-0'>
          <AiFillBug className='h-6 w-6 text-red-500' aria-hidden='true' />
        </div>
        <div className='ml-3'>
          <h1 className='text-lg font-medium text-red-800'>
            Oops! Something went wrong on our end...
          </h1>
          <div className='mt-2 text-sm text-red-600'>
            <p>Possible solution:</p>
            <ul className='list-disc gap-y-1 pl-5'>
              <li>Clear your cache and cookies and try again.</li>
            </ul>
          </div>
          <div className='my-6 mt-2 text-base text-red-600'>
            If the issue persists after trying the solution above please contact
            HireMySub Support team through our{' '}
            <Link
              to='/contact-us'
              onClick={resetErrorBoundary}
              className='text-primary-blue cursor-pointer underline'
            >
              Contact Us
            </Link>{' '}
            page, by email at{' '}
            <a
              href='mailto:contact@hiremysub.com'
              className='text-primary-blue cursor-pointer underline'
            >
              contact@hiremysub.com
            </a>{' '}
            or by phone at{' '}
            <a
              href='tel:8668449844'
              className='text-primary-blue cursor-pointer underline'
            >
              866-844-9844
            </a>
            .
          </div>
          <Link
            to='/'
            onClick={resetErrorBoundary}
            className='bg-primary-blue rounded px-3 py-2 text-white'
          >
            Home
          </Link>
        </div>
      </div>
    </main>
  );
};

export default FallbackErrorPage;
